& .download-modal-time-input {
  width: 40% !important;
}
